import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=3938f80d&scoped=true"
import script from "./Whiteboard.vue?vue&type=script&lang=js"
export * from "./Whiteboard.vue?vue&type=script&lang=js"
import style0 from "./Whiteboard.vue?vue&type=style&index=0&id=3938f80d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938f80d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3938f80d')) {
      api.createRecord('3938f80d', component.options)
    } else {
      api.reload('3938f80d', component.options)
    }
    module.hot.accept("./Whiteboard.vue?vue&type=template&id=3938f80d&scoped=true", function () {
      api.rerender('3938f80d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Whiteboard.vue"
export default component.exports